import React, { useEffect, useState } from 'react'
import anime from 'animejs'
import classNames from 'classnames'
import { themeColors, logoOutlineSvgPathDrawings } from 'training-lane-booking-shared/utilities/constants'
import { WATCHDOG_TIMEOUT_MS, handleStalledSpinner } from 'src/utils/loadingWatchdog'
import logoLoadingClasses from './LogoLoading.module.scss'

const LogoLoading = ({ source = 'unknown' }) => {
    const [stalled, setStalled] = useState(false)

    useEffect(() => {
        // noinspection JSUnusedGlobalSymbols
        anime({
            targets: '.logo-loading .lines path',
            strokeLinecap: 'round',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 1000,
            delay: (el, i) => i * 250,
            direction: 'alternate',
            loop: true
        })
    }, [])

    useEffect(() => {
        let timer = null

        // only count time while the page is visible, as mobile browsers
        // pause background tabs and loading resumes when brought back
        const startTimer = () => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                setStalled(true)
                handleStalledSpinner(source)
            }, WATCHDOG_TIMEOUT_MS)
        }

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                startTimer()
            } else {
                clearTimeout(timer)
            }
        }

        // page restored from the back/forward cache with the spinner showing:
        // connections are likely dead, start fresh
        const onPageShow = event => {
            if (event.persisted) {
                window.location.reload()
            }
        }

        if (document.visibilityState === 'visible') {
            startTimer()
        }
        document.addEventListener('visibilitychange', onVisibilityChange)
        window.addEventListener('pageshow', onPageShow)

        return () => {
            clearTimeout(timer)
            document.removeEventListener('visibilitychange', onVisibilityChange)
            window.removeEventListener('pageshow', onPageShow)
        }
    }, [source])

    return (
        <div className={classNames("logo-loading", logoLoadingClasses.loading)}>
            <svg width={200} height={200} viewBox="513 330 330 540">
                <g fill="none" fillRule="evenodd" strokeWidth="5" className="lines">
                    {
                        logoOutlineSvgPathDrawings.blue.map(d => <path key={d} d={d} stroke={themeColors.brandBlue} />)
                    }
                    {
                        logoOutlineSvgPathDrawings.red.map(d => <path key={d} d={d} stroke={themeColors.brandRed} />)
                    }
                </g>
            </svg>
            {stalled && (
                <div className={logoLoadingClasses.stalled}>
                    <p>This is taking longer than expected.</p>
                    <button onClick={() => window.location.reload()}>Reload</button>
                </div>
            )}
        </div>
    )
}

export default LogoLoading
